import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-begiftigde',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-begiftigde.component.html',
  styleUrl: './tekst-begiftigde.component.scss',
})
export class TekstBegiftigdeComponent {}
